import React, { useState, useEffect } from "react";
import "./Hero.css";


import car1 from "../assets/car1.jpg";
import car2 from "../assets/car2.jpg";
import car3 from "../assets/car3.jpg";
import car4 from "../assets/car4.jpg";
import image3 from "../assets/image3.jpg";
import image2 from "../assets/image2.jpg";

const images = [
  car1,
  car2,
  car3,
  car4,
  image3,
  image2
  
];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">
      <img
        src={images[index]}
        alt="flower"
        className="hero-img"
        style={{ opacity: fade ? 1 : 0 }}
      />

      <div className="hero-overlay">
        <h1>🌸New Kalpana Nursery🌸 </h1>
        <p>Fresh Flowers for Every Occasion</p>
      </div>
    </div>
  );
};

export default Hero;